export const ENDPOINTS = {
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    me: '/auth/me',
  },
  dashboards: {
    list: '/dashboards',
    detail: (id: string) => `/dashboards/${id}`,
    versions: (id: string) => `/dashboards/${id}/versions`,
    clone: (id: string) => `/dashboards/${id}/clone`,
  },
  widgets: {
    catalog: '/widgets/catalog',
    data: (type: string) => `/widgets/${type}/data`,
  },
  users: {
    list: '/users',
    detail: (id: string) => `/users/${id}`,
  },
  roles: {
    list: '/roles',
    detail: (id: string) => `/roles/${id}`,
  },
  permissions: {
    list: '/permissions',
  },
  notifications: {
    list: '/notifications',
    markRead: (id: string) => `/notifications/${id}/read`,
    markAllRead: '/notifications/read-all',
  },
  reports: {
    list: '/reports',
    detail: (id: string) => `/reports/${id}`,
    run: (id: string) => `/reports/${id}/run`,
    download: (id: string) => `/reports/${id}/download`,
  },
  audit: {
    list: '/audit-logs',
  },
} as const;
